"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Ultra = function Ultra(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "680.3px",
    height: "737px",
    viewBox: "0 0 680.3 737"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M121.5,257.3c0,37.1-0.7,74.1,0.2,111.2c1.6,73.9,33.8,132.4,93.8,175.1c38.1,27.2,81.2,40.5,127.7,39.6 c111.3-1.9,201.5-82.9,215.6-187.9c2.6-19,2.8-38.3,2.9-57.6c0.5-58.6,0.3-117.2,0.3-175.8c0-10-1-20-1-30.2c0-3.1,2.1-6.2,3.3-9.1 c2.9,1.6,6.4,2.4,8.6,4.5c56.7,55.2,91.5,121.5,100.7,200.5c18.3,156.5-69.6,300.8-219.4,354C280.1,743.8,91.9,656.5,26.5,485.2 C10,441.8,2.6,396.4,5.7,350.1c5.7-87.9,40-162.9,104.1-223.7c2.2-2.1,5.9-2.9,8.8-4.3c1,3.1,2.8,6.2,2.8,9.3 C121.7,173.4,121.5,215.3,121.5,257.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M238.6,221.3c0-49.5,0-98.8,0-148.2c0-13.8,5.9-24.3,19.1-27.2c21.4-4.8,43.3-8.4,65.2-10.3 c31.5-2.6,63.1,0.2,93.8,8.3c15.3,4,23.4,13.4,24.3,29.3c0.9,14.8,1.6,29.8,1.6,44.6c0,78.9-0.3,157.9-0.2,237 c0.2,41.9-14.7,75.7-51.7,97.4c-66.4,39-151.3-9.1-152.2-86C238.2,317.8,238.6,269.6,238.6,221.3z"
  })));
};
Ultra.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Ultra.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Ultra;